module.exports = __webpack_public_path__ + "fonts/obelixpro-broken-cyr-webfont.fdd0bfc8.woff";